export default {
  DEFAULTS: {},
  CURSOR: {
    GRABBING: "grabbing",
    GRAB: "grab",
    POINTER: "pointer"
  }
};